import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Modal,
  Button,
  Table,
  Badge,
} from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";

import {
  testmenuGetAgency,
  testmenuDeleteAgency,
} from "../../api/testMenuService";

function MyPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [agencyDetails, setAgencyDetails] = useState(null);

  const fetcAgency = async () => {
    try {
      const response = await testmenuGetAgency(id);
      setAgencyDetails(response);
      console.log("response: ", response);
    } catch (error) {
      console.error("Error fetching agency details:", error);
    }
  };

  useEffect(() => {
    fetcAgency();
  }, []);

  const handleDelete = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this agency?"
    );
    if (!confirmDelete) return;

    try {
      await testmenuDeleteAgency(id);
      alert("Agency deleted successfully.");
      navigate("/testmenu/list");
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete agency.");
    }
  };

  return (
    <Card className="mt-4">
      <Card.Body>
        {agencyDetails && (
          <div>
            ID: {agencyDetails.id}
            <br />
            Agency Name: {agencyDetails.agencyName}
            <br />
            Phone No.: {agencyDetails.phoneNumber}
            <br />
            <br />
            <Link
              to={`/testmenu/agency/update/${agencyDetails.id}`}
              className=""
            >
              <Button variant="primary" size="sm">
                Edit
              </Button>
            </Link>
            <Button
              variant="danger"
              size="sm"
              className="ml-2"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default MyPage;
